import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getMain() {
        try
        {            
            const response = await axios.get(`Payroll`,
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('payroll api getMain error')
            throw error
        }
    },
    async getByCompany(cutOffId) {
        try
        {            
            const response = await axios.get(`Payroll/${cutOffId}`,
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('payroll api getByCompany error')
            throw error
        }
    },
    async getByUser(cutOffId, userId) {
        try
        {            
            const response = await axios.get(`Payroll/${cutOffId}/user/${userId}`,
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('payroll api getByUser error')
            throw error
        }
    },
    async generateByUser(data) {
        try
        {            
            const response = await axios.post(`Payroll/generate/user`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                       
            return response
        }
        catch (error)
        {
            console.log('payroll api generateByUser error')
            throw error
        }
    },
    async forReview(data) {
        try
        {            
            const response = await axios.post(`Payroll/forreview`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('payroll api forReview error')
            throw error
        }
    },
    async approve(data) {
        try
        {            
            const response = await axios.post(`Payroll/approve`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('payroll api approve error')
            throw error
        }
    },
    async reject(data) {
        try
        {            
            const response = await axios.post(`Payroll/reject`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('payroll api reject error')
            throw error
        }
    },
    async publish(data) {
        try
        {            
            const response = await axios.post(`Payroll/publish`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('payroll api publish error')
            throw error
        }
    },
    async payrollCredited(data) {
        try
        {            
            //this will only update status to Credited
            const response = await axios.post(`Payroll/payroll-credited`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('payroll api payrollCredited error')
            throw error
        }
    },
    async getControlReport(cutOffId) {
        try
        {            
            const response = await axios.get(`Payroll/control-report/${cutOffId}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.payroll
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getControlReport error')
            throw error
        }
    },
    async generatePaylipPDF(data) {
        try
        {            
            const response = await axios.post(`Payroll/payslip/pdf`, 
            {
                item: data
            },
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.payroll
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api generatePaylipPDF error')
            throw error
        }
    },
    async getMyPayslipMain() {
        try
        {        
            const response = await axios.get(`Payroll/my-payslip`,
            {
                headers: {
                    'page_key': pageKeys.mypayslip
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getMyPayslipMain error')
            throw error
        }
    },
    async getMyPayslip(cutoffId) {
        try
        {        
            //for my payslip page only
            const response = await axios.get(`Payroll/my-payslip/${cutoffId}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.mypayslip	
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getMyPayslip error')
            throw error
        }
    },
    async getMyPayslipUrl(cutoffId) {
        try
        {    
            //for my payslip page only    
            const response = await axios.get(`Payroll/my-payslip/pre-signed-url/${cutoffId}`,
            {
                headers: {
                    'page_key': pageKeys.mypayslip	
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getMyPayslip error')
            throw error
        }
    },
    async getPayslipUrl(data) {
        try
        {        
            //use in payroll processing page
            const response = await axios.get(`Payroll/${data.userId}/payslip/pre-signed-url/${data.cutOffId}`,
            {
                headers: {
                    'page_key': pageKeys.payroll	
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getMyPayslip error')
            throw error
        }
    },
    async getMyAnnualization(fiscalYear) {
        try
        {        
            const response = await axios.get(`Payroll/myannualization/${fiscalYear}`,
            {
                headers: {
                    'page_key': pageKeys.mypayslip	
                }
            })            
            return response
        }
        catch(error)
        {
            console.log('payroll api getMyAnnualization error')
            throw error
        }
    },
    async getMyAnnualizationReport(fiscalPeriodId) {
        try
        {        
            const response = await axios.get(`Payroll/myannualization/pdf/${fiscalPeriodId}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.mypayslip	
                }
            })            
            return response
        }
        catch(error)
        {
            console.log('payroll api getMyAnnualizationReport error')
            throw error
        }
    },
    async getMy2316Report(fiscalPeriodId) {
        try
        {        
            const response = await axios.get(`Payroll/myannualization/pdf/2316/${fiscalPeriodId}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.mypayslip	
                }
            })            
            return response
        }
        catch(error)
        {
            console.log('payroll api getMy2316Report error')
            throw error
        }
    },
    async get1601C(cutoffId) {
        try
        {        
            const response = await axios.get(`Payroll/pdf/1601C/${cutoffId}`, 
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.payroll	
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api get1601C error')
            throw error
        }
    },
    async get1601CUrl(cutoffId) {
        try
        {        
            const response = await axios.get(`Payroll/pre-signed-url/1601C/${cutoffId}`, 
            {
                headers: {
                    'page_key': pageKeys.payroll	
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api get1601CUrl error')
            throw error
        }
    },
    async get1603Q(cutoffId) {
        try
        {        
            const response = await axios.get(`Payroll/pdf/1603Q/${cutoffId}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.payroll
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api get1603Q error')
            throw error
        }
    },
    async get1603QUrl(cutoffId) {
        try
        {        
            const response = await axios.get(`Payroll/pre-signed-url/1603Q/${cutoffId}`,
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api get1603QUrl error')
            throw error
        }
    },
    async getPayrollDepositSlip(cutoffId) {
        try
        {        
            const response = await axios.get(`Payroll/pdf/deposit-slip/${cutoffId}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.payroll
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getPayrollDepositSlip error')
            throw error
        }
    },
    async getPayrollDepositSlipUrl(cutoffId) {
        try
        {        
            const response = await axios.get(`Payroll/pdf/deposit-slip/pre-signed-url/${cutoffId}`,
            {
                headers: {
                    'page_key': pageKeys.payroll
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getPayrollDepositSlipUrl error')
            throw error
        }
    },
    async getSSSContributionsSummary() {
        try
        {        
            const response = await axios.get(`Payroll/sss`,
            {
                headers: {
                    'page_key': pageKeys.sss
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getSSSContributionsSummary error')
            throw error
        }
    },
    async getSSSContributionsDetails(data) {
        try
        {        
            const response = await axios.get(`Payroll/sss/${data.fiscalYear}/${data.month}`,
            {
                headers: {
                    'page_key': pageKeys.sss
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getSSSContributionsDetails error')
            throw error
        }
    },
    async getSSSContributionsXls(data) {
        try
        {            
            const response = await axios.get(`Payroll/sss/xls/${data.fiscalYear}/${data.month}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.sss
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getSSSContributionsXls error')
            throw error
        }
    },
    async setSSSContributionsPaid(data) {
        try
        {        
            const response = await axios.post(`Payroll/sss/paid/${data.fiscalYear}/${data.month}`,            
            {},
            {
                headers: {
                    'page_key': pageKeys.sss
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api SSSContributionsPaid error')
            throw error
        }
    },
    async getPagibigContributionsSummary() {
        try
        {        
            const response = await axios.get(`Payroll/pagibig`,
            {
                headers: {
                    'page_key': pageKeys.pagibig
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getPagibigContributionsSummary error')
            throw error
        }
    },
    async getPagibigContributionsDetails(data) {
        try
        {        
            const response = await axios.get(`Payroll/pagibig/${data.fiscalYear}/${data.month}`,
            {
                headers: {
                    'page_key': pageKeys.pagibig
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getSSSContributionsDetails error')
            throw error
        }
    },
    async getPagibigContributionsXls(data) {
        try
        {            
            const response = await axios.get(`Payroll/pagibig/xls/${data.fiscalYear}/${data.month}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.pagibig
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getPagibigContributionsXls error')
            throw error
        }
    },
    async setPagibigContributionsPaid(data) {
        try
        {        
            const response = await axios.post(`Payroll/pagibig/paid/${data.fiscalYear}/${data.month}`,            
            {},
            {
                headers: {
                    'page_key': pageKeys.pagibig
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api setPagibigContributionsPaid error')
            throw error
        }
    },
    async getPhilhealthContributionsSummary() {
        try
        {        
            const response = await axios.get(`Payroll/philhealth`,
            {
                headers: {
                    'page_key': pageKeys.philhealth
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getPhilhealthContributionsSummary error')
            throw error
        }
    },
    async getPhilhealthContributionsDetails(data) {
        try
        {        
            const response = await axios.get(`Payroll/philhealth/${data.fiscalYear}/${data.month}`,
            {
                headers: {
                    'page_key': pageKeys.philhealth
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getPhilhealthContributionsDetails error')
            throw error
        }
    },
    async getPhilhealthContributionsXls(data) {
        try
        {            
            const response = await axios.get(`Payroll/philhealth/xls/${data.fiscalYear}/${data.month}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.philhealth
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getPhilhealthContributionsXls error')
            throw error
        }
    },
    async setPhilhealthContributionsPaid(data) {
        try
        {        
            const response = await axios.post(`Payroll/philhealth/paid/${data.fiscalYear}/${data.month}`,            
            {},
            {
                headers: {
                    'page_key': pageKeys.philhealth
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api setPhilhealthContributionsPaid error')
            throw error
        }
    },
    async getReferenceTables() {
        try
        {        
            const response = await axios.get(`Payroll/reference-tables`,
            {
                headers: {
                    'page_key': pageKeys.reference_tables
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getReferenceTables error')
            throw error
        }
    },
}